<template>
  <div id="app" class="app">
    <!-- <a-button size="small" type="primary" @click="setLanguage('zh_CN')">中文</a-button>
    <a-button type="primary" @click="setLanguage('en_GB')">英文</a-button> -->
    <a-config-provider :locale="locale">
      <router-view />
    </a-config-provider>
  </div>
</template>

<script>
import Layout from '@/layout';
import vi_VN from 'ant-design-vue/lib/locale-provider/vi_VN';
export default {
  components: { Layout },
  data() {
    return {
      language: "zh_CN",
      locale: vi_VN,
    };
  },
  created() {
    this.getLanguage();
  },
  methods: {
    setLanguage(value = "zh_CN") {
      this.language = value;
      this.getLanguage();
    },
    async getLanguage() {
      let res = await import(`ant-design-vue/lib/locale-provider/${this.language}`);
      this.locale = res.default;
    }
  }
}
</script>